import React, { useState } from "react"
import Facebook from "../../../assets/facebook.svg"
import PaperPlane from "../../../assets/paper-plane.svg"
import Printer from "../../../assets/printer.svg"
import Link from "../../../assets/link.svg"
import { motion } from "framer-motion"

const SocialSharing = ({ style, simple, isRecipe }) => {
  const [showSnek, setShowSnek] = useState(false)

  const copyUrl = value => {
    if (showSnek) return
    setShowSnek(true)
    const tempInput = document.createElement("input")
    tempInput.style = "position: absolute; left: -1000px; top: -1000px"
    tempInput.value = value
    document.body.appendChild(tempInput)
    tempInput.select()
    document.execCommand("copy")
    document.body.removeChild(tempInput)
    setTimeout(() => {
      setShowSnek(false)
    }, 5000)
  }

  return (
    <>
      <ul style={style} className={`social-sharing${simple ? "--simple" : ""}`}>
        <li className="social-sharing__item">
          <a
            href={
              typeof window !== "undefined" &&
              `https://www.facebook.com/sharer/sharer.php?${encodeURIComponent(
                window.location.href
              )}`
            }
          >
            <img src={Facebook} />
          </a>
        </li>
        <li className="social-sharing__item">
          <a
            href={
              typeof window !== "undefined" &&
              `mailto:?subject=${"Check out this article from VeraMexicana.com"}&body=${encodeURIComponent(
                window.location.href
              )}`
            }
          >
            <img src={PaperPlane} />
          </a>
        </li>
        <li className="social-sharing__item">
          <a
            href={typeof window !== "undefined" && `javascript:window.print();`}
          >
            <img src={Printer} />
          </a>
        </li>
        <li className="social-sharing__item" style={{ position: "relative" }}>
          {showSnek && <Snek isRecipe={isRecipe} />}
          {/* <Snek isRecipe={isRecipe} /> */}
          <img
            style={{ cursor: "pointer" }}
            src={Link}
            onClick={
              typeof window !== "undefined"
                ? () => copyUrl(window.location.href)
                : () => {}
            }
          />
        </li>
        {!simple && (
          <li
            className="social-sharing__item"
            style={{ marginRight: "10px" }}
          ></li>
        )}
      </ul>
    </>
  )
}

export default SocialSharing

const Snek = ({ isRecipe }) => {
  const variants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1 },
  }

  return (
    <motion.div
      initial="hidden"
      animate="visible"
      variants={variants}
      className="snek"
      transition={{ duration: 0.5 }}
      style={isRecipe ? { padding: "12px 10px" } : {}}
    >
      Link copied · press Ctrl+V to use it
    </motion.div>
  )
}
